import { useQuery } from '@tanstack/react-query';
import { apiClient } from 'src/libs/axios';
import { QueryOptions } from 'src/libs/react-query';
import { CurrentLeaderboardResponse } from './get-current-leaderboard';
import { leaderboardKeys } from './leaderboard-keys';

interface GetLeaderboardParams {
  page: number;
  page_size: number;
  sort_by?: string;
  sort_order?: 'desc' | 'asc';
}
export const getLeaderboardById = async (
  id: string,
  params: GetLeaderboardParams,
  userAddress?: string,
) => {
  const response = await apiClient.get<CurrentLeaderboardResponse>(
    '/v1/public/user-leaderboard/' + id,
    {
      params: {
        useraddress: userAddress,
        ...params,
      },
    },
  );

  return response.data;
};

export type UseGetAvailableBalanceLPOptions<TData, TError> = QueryOptions<
  CurrentLeaderboardResponse,
  TError,
  CurrentLeaderboardResponse,
  ReturnType<typeof leaderboardKeys.getLeaderboardById>
>;

export const useGetLeaderboardById = <TData = CurrentLeaderboardResponse, TError = Error>(
  id: string,
  params: GetLeaderboardParams,
  userAddress?: string,
  options?: UseGetAvailableBalanceLPOptions<TData, TError>,
) => {
  return useQuery({
    queryKey: leaderboardKeys.getLeaderboardById(id, params, userAddress),
    queryFn: () => getLeaderboardById(id, params, userAddress),
    enabled: !!id,
    ...options,
  });
};
